import { configureStore } from "@reduxjs/toolkit";

import adminReducer from "./pages/registration/registrationSlice";
import registerReducer from "./pages/comfirmRegistration/confirmRegistrationSlice";
import loginReducer from "./pages/admin-login/loginSlice";
import userReducer from "./pages/admin-dashboard-page/userSlice";
import passReducer from "./pages/password-reset/passSlice";
import systemReducer from "./systemSlice";
import studentLeadReducer from "./pages/lead/leadSlice";
import ambassadorReducer from "./pages/ambassador/ambassadorSlice";
import referralCodeReducer from "./pages/referral-code/referralCodeSlice";
import enrolmentReducer from "../src/pages/enrolment/enrolmentSlice";
import studentReducer from "../src/pages/student/studentSlice";
import preEnrolmentReducer from "../src/pages/pre-enrolment/preEnrolmentSlice";
import blogReducer from "../src/pages/blogs/blogSlice";
import courseReducer from "./pages/course/courseSlice";
import reviewReducer from "./pages/reviews/reviewSlice";
import stageReducer from "./pages/lead/stageSlice";
import testimonialReducer from "./pages/testimonials/TestimonialsSlice";
import eventReducer from "./pages/events/EventSlice";
import careerReducer from "./pages/careers/CareerSlice";
import freeResourceReducer from "./pages/free-resources/freeResourceSlice";

const store = configureStore({
  reducer: {
    login: loginReducer,
    user: userReducer,
    password: passReducer,
    Registration: adminReducer,
    ConfirmRegister: registerReducer,
    systemState: systemReducer,
    studentLead: studentLeadReducer,
    ambassadorUser: ambassadorReducer,
    referralCode: referralCodeReducer,
    enroll: enrolmentReducer,
    preEnrol: preEnrolmentReducer,
    student: studentReducer,
    blog: blogReducer,
    course: courseReducer,
    review: reviewReducer,
    stage: stageReducer,
    testimonial: testimonialReducer,
    event: eventReducer,
    career: careerReducer,
    freeResource: freeResourceReducer,
  },
});

export default store;
